import { isRNDev } from "utilities/src/environment/env";
export const isDetoxBuild = Boolean(process.env.DETOX_MODE);
export const isJestRun = !!process.env.JEST_WORKER_ID;
export const isNonJestDev = isRNDev() && !isJestRun;
export const localDevDatadogEnabled = false;
export const datadogEnabled = (localDevDatadogEnabled || !isRNDev()) && !isJestRun;
